module.exports = __webpack_public_path__ + "static/media/BPPOA-By-Laws.d6777921.pdf";